import Swal from "sweetalert2";
export const handleCreateCar = async (
  formData,
  {
    setIsCreatingCar,
    cars,
    fetchData,
    setCreateCarModalOpen,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  try {
    setIsCreatingCar(true);
    await cars.create(formData);

    await Swal.fire({
      icon: "success",
      title: "Success",
      text: "Car created successfully!",
      confirmButtonColor: "#1e3a8a",    });
    fetchData();
    setCreateCarModalOpen(false);
  } catch (error) {
    console.error("Error creating car:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to create car. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setIsCreatingCar(false);
  }
};
